import useTranslation from "../../common/translations";
import React, { useEffect, useRef, useState } from "react";
export default function SearchHeader({ onBack, onQueryChange, }) {
    const { t } = useTranslation("site-search");
    const inputRef = useRef(null);
    const debounceRef = useRef(null);
    const [hasValue, setHasValue] = useState(false);
    // Autofocus when component mounts
    useEffect(() => {
        const id = window.setTimeout(() => { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }, 0);
        return () => window.clearTimeout(id);
    }, []);
    useEffect(() => {
        return () => {
            if (debounceRef.current !== null)
                window.clearTimeout(debounceRef.current);
        };
    }, []);
    function handleChange() {
        var _a, _b;
        const value = (_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "";
        setHasValue(value.length > 0);
        if (debounceRef.current !== null)
            window.clearTimeout(debounceRef.current);
        debounceRef.current = window.setTimeout(() => {
            onQueryChange(value);
        }, 500);
    }
    function handleClear() {
        if (inputRef.current)
            inputRef.current.value = "";
        setHasValue(false);
        if (debounceRef.current !== null)
            window.clearTimeout(debounceRef.current);
        onQueryChange("");
    }
    return (<div className="sticky top-0 z-10 bg-white">
      <div className="flex items-center gap-2 p-4">
        <button type="button" aria-label={t("search.header.back_aria")} className="size-[45px] flex items-center justify-center -ml-4 cursor-pointer" onClick={onBack}>
          <svg className="size-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M15.5473 2L6 11.293V12.707L15.5473 22H17V20.586L8.17956 12L17 3.414V2H15.5473Z" fill="currentColor"/>
          </svg>
        </button>

        <div className="flex-1">
          <div className="flex items-center rounded-full bg-[#EBECEF] border border-[#020309]">
            <input name="query" ref={inputRef} onChange={handleChange} placeholder={t("search.header.placeholder")} autoComplete="off" className="flex-1 bg-transparent border-none focus:ring-0 p-0 h-[43px] px-5"/>
            {hasValue ? (<button type="button" aria-label={t("search.header.clear_aria")} className="w-10 h-10 flex items-center justify-center mr-2.5" onClick={handleClear}>
                <svg className="size-5" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M10 0C4.477 0 0 4.477 0 10C0 15.522 4.477 20 10 20C15.523 20 20 15.522 20 10C20 4.477 15.523 0 10 0ZM10.0118 8.65766L7.43078 6.07666H6.01678V7.49066L8.59778 10.0717L6.01678 12.6527V14.0667H7.43078L10.0118 11.4857L12.5928 14.0667H14.0068V12.6527L11.4258 10.0717L14.0068 7.49066V6.07666H12.5928L10.0118 8.65766Z" fill="currentColor"/>
                </svg>
              </button>) : null}
          </div>
        </div>
      </div>
    </div>);
}
